/**
 * FlowOverlayMetricLabels — Current/New/Diff column labels for the country
 * Flows overlay. Mirrors each row's grid + the fixed metric grid
 * (grid-cols-[3rem_0.75rem_3rem_3.25rem]) so the labels sit over their values.
 * The metric block is right-anchored (before the toggle, w-11) so the variable
 * name/profit columns never shift it.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

const LABEL =
  'text-right text-[9px] font-medium uppercase tracking-wide text-muted-foreground/70';

/** The three metric labels in the shared fixed columns (current/arrow/new/diff). */
const MetricLabelCells: FC = () => (
  <>
    <span className={LABEL}>Current</span>
    <span aria-hidden />
    <span className={LABEL}>New</span>
    <span className={LABEL}>Diff</span>
  </>
);

export interface FlowOverlayMetricLabelsProps {
  /** 'paths' mirrors FlowPathsPathRow; 'item' mirrors FlowWeightedItemRow. */
  variant: 'paths' | 'item';
}

// Flat grids that exactly match each row's preview grid, so the labels sit in
// the same top-level Current/New/Diff column tracks the values render in.
export const FlowOverlayMetricLabels: FC<FlowOverlayMetricLabelsProps> = ({ variant }) => {
  if (variant === 'paths') {
    return (
      <div className="grid w-full items-center gap-x-1.5 px-1.5 pb-1 grid-cols-[1.5rem_1.5rem_minmax(0,1fr)_3rem_0.75rem_3rem_3.25rem_2.75rem]">
        <span aria-hidden />
        <span aria-hidden />
        <span aria-hidden />
        <MetricLabelCells />
        <span aria-hidden />
      </div>
    );
  }
  return (
    <div className="grid w-full items-center gap-x-1.5 px-1.5 grid-cols-[1.5rem_1.5rem_minmax(0,1fr)_3rem_0.75rem_3rem_3.25rem_2.75rem]">
      <span aria-hidden />
      <span aria-hidden />
      <span aria-hidden />
      <MetricLabelCells />
      <span aria-hidden />
    </div>
  );
};

export default FlowOverlayMetricLabels;
